import type { BrandCode } from './brand-context';

export type BrandHostMapping = readonly [RegExp, BrandCode];

export const brandAliases: Record<string, BrandCode> = {
  // Gesmap
  gm: 'gm',
  gesmap: 'gm',
  prod: 'gm',
  develop: 'gm',
  feature: 'gm',
  fr: 'gm',
  lu: 'gm',
  en: 'gm',
  de: 'gm',
  // Gesroute
  gr: 'gr',
  gesroute: 'gr',
  prodroute: 'gr',
  // Gesbat
  gb: 'gb',
  gesbats: 'gb',
  prodbats: 'gb',
  // GesBus
  bu: 'bu',
  gesbus: 'bu',
  prodbus: 'bu',
  // Mobilites
  mo: 'mo',
  mobilites: 'mo',
  gesmobilites: 'mo',
  prodmobilites: 'mo',
  // Dechets
  dc: 'dc',
  gesdechets: 'dc',
  proddechets: 'dc',
  // Ageroute
  ag: 'ag',
  ageroute: 'ag',
  prodageroute: 'ag',
};

export const brandSchemes: Record<BrandCode, string> = {
  gm: 'gesmap',
  gr: 'gesroute',
  gb: 'gesbats',
  bu: 'gesbus',
  mo: 'gesmobilites',
  dc: 'gesdechets',
  ag: 'ageroute',
};

export const brandHostMappings: BrandHostMapping[] = [
  [/^app\.gesmap\.fr$/i, 'gm'],
  [/^develop--gesmap-app\.netlify\.app$/i, 'gm'],
  [/^feature--nevertim-app\.netlify\.app$/i, 'gm'],
  [/^preview\.gesmap\.local$/i, 'gm'],
  [/^app\.gesroute\.fr$/i, 'gr'],
  [/^preview\.gesroute\.local$/i, 'gr'],
  [/^app\.gesbats\.fr$/i, 'gb'],
  [/^preview\.gesbats\.local$/i, 'gb'],
  [/^app\.gesbus\.fr$/i, 'bu'],
  [/^preview\.gesbus\.local$/i, 'bu'],
  [/^app\.gesmobilites\.fr$/i, 'mo'],
  [/^www\.gesmobilites\.fr$/i, 'mo'],
  [/^preview\.gesmobilites\.local$/i, 'mo'],
  [/^app\.gesdechets\.fr$/i, 'dc'],
  [/^preview\.gesdechets\.local$/i, 'dc'],
  [/^gesmap-ageroute-app\.netlify\.app$/i, 'ag'],
  [/^feature--ugauapp\.netlify\.app$/i, 'ag'],
  [/^preview\.ageroute\.local$/i, 'ag'],
];
